import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import StudentPerformanceAnalytics from "PerformanceAnalytics/routes/StudentPerformanceAnalytics";
import SubjectPerformanceAnalytics from "PerformanceAnalytics/routes/SubjectPerformanceAnalytics";
import LearningCoursePerformanceAnalytics from "PerformanceAnalytics/routes/LearningCoursePerformanceAnalytics";
export default store => {
  return {
    path: ":gradeId",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "year-group-id" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      StudentPerformanceAnalytics(store),
      SubjectPerformanceAnalytics(store),
      LearningCoursePerformanceAnalytics(store),
    ],
  };
};
